import React, { useState } from 'react';
import {
  Lock,
  SlidersHorizontal,
  Mic,
  Code,
  CreditCard,
  LogOut,
} from 'lucide-react';

const Sidebar = ({ user }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [currentPath, setCurrentPath] = useState('/dashboard');

  const navLinks = [
    { path: '/',            name: 'Text To Speech', icon: Mic },
    { path: '/developer',   name: 'Developer',      icon: Code },
    { path: '/subscription',name: 'Subscription',   icon: CreditCard },
    { path: '/',    name: 'Finetune',       icon: Lock },
  ];

  const handleLogout = () => console.log('Logging out…');

  const navigateTo = (path) => {
    setCurrentPath(path);
    if (window.innerWidth < 1024) setSidebarOpen(false);
  };

  return (
    <div
      className={`fixed lg:static inset-y-0 left-0 transform ${
        sidebarOpen ? 'translate-x-0' : '-translate-x-full'
      } w-64 bg-white border-r border-gray-200 transition-transform duration-300 ease-in-out lg:translate-x-0 z-10`}
    >
      {/* Logo */}
      <div className="flex items-center h-12 mt-2 px-4 mb-6">
        <span className="text-base  text-black font-bold">Orpheus Platform</span>
      </div>

      <div className="flex items-center mt-2 mb-2">
        <span className="text-base text-gray-500 px-6 font-medium text-sm">Platform</span>
      </div>

      {/* Nav */}
  {navLinks.map(({ path, name, icon: Icon }) => (
    <a
      key={path}
      href={path}
      onClick={(e) => {
        navigateTo(path);
      }}
      className={`flex items-center px-6 py-2 ml-1 mr-1 text-sm transition-colors duration-200 rounded ${
        currentPath === path
          ? 'bg-gray-100 text-black'
          : 'text-black hover:bg-gray-100 hover:rounded'
      }`}
    >
      <Icon size={12} className="mr-3 text-black" />
      {name}
    </a>
  ))}

      {/* User / logout */}
      <div className="absolute bottom-0 w-full p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-sm font-medium text-gray-700">
              {user?.email?.[0]?.toUpperCase() || 'U'}
            </div>
            <div className="ml-3">
              <p className="text-sm font-medium text-gray-700">{user?.email}</p>
              <p className="text-xs text-gray-500">User</p>
            </div>
          </div>
          <button
            onClick={handleLogout}
            className="p-2 text-gray-500 hover:text-gray-700 transition-colors duration-200"
          >
            <LogOut size={20} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
